const Typography = {
  thin: {
    fontWeight: '100',
    includeFontPadding: false,
  },
  extraLight: {
    fontWeight: '200',
    includeFontPadding: false,
  },
  light: {
    fontWeight: '300',
    includeFontPadding: false,
  },
  regular: {
    fontWeight: '400',
    includeFontPadding: false,
  },
  medium: {
    fontWeight: '500',
    includeFontPadding: false,
  },
  semiBold: {
    fontWeight: '600',
    includeFontPadding: false,
  },
  bold: {
    fontWeight: '700',
    includeFontPadding: false,
  },
  extraBold: {
    fontWeight: '800',
    includeFontPadding: false,
  },
  black: {
    fontWeight: '900',
    includeFontPadding: false,
  },
};

export default Typography;
